<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-chicken-drumstick`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.356 20.018c-3.586-.4-8.211 1.2-11.404 4.397-3.985 3.994-3.855 8.957-.1 12.72 3.756 3.762 8.71 3.893 12.695-.1 3.152-3.158 4.748-7.715 4.404-11.289-.156-1.621-.713-3.04-1.705-4.035-.963-.965-2.328-1.519-3.89-1.693zm8.003.482l3.626-3.633 1.363.905a2.997 2.997 0 003.774-.384 3.01 3.01 0 00-1.695-5.1l-1.487-.212-.212-1.49a2.985 2.985 0 00-.848-1.699 2.996 2.996 0 00-4.242 0 3.011 3.011 0 00-.384 3.781l.903 1.366-3.61 3.616a9.128 9.128 0 012.812 2.85zm-6.94-4.38l2.746-2.751a7.026 7.026 0 011.645-7.315 6.99 6.99 0 019.898 0 6.998 6.998 0 011.644 2.602 7.022 7.022 0 012.598 11.565 6.994 6.994 0 01-7.301 1.648l-2.801 2.807c.746 4.996-1.35 11.052-5.481 15.192-5.581 5.591-13.06 5.394-18.343.1-5.283-5.293-5.48-12.786.1-18.377 4.168-4.176 10.284-6.276 15.295-5.471z"/></svg>
</template>
<script>

export default {
  name: 'IconChickenDrumstick',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
